import { useQuery } from "@tanstack/react-query";
import { fetchProduct } from "./api/products";

export const useGetProduct = (slug, user_id = null, token = null) => {
  return useQuery({
    queryKey: ["product", slug, user_id],
    queryFn: () => fetchProduct(slug, user_id, token),
    enabled: !!slug,
  });
};
